import {
  MemberStatusChangeRequestAuditForm,
  MemberStatusChangeRequestForm,
} from '@act/shared/data-transfer-objects';
import type { UpdateMemberStatusChangeRequestRequest } from '@act/shared/types';
import { DateTime } from 'luxon';

interface BuildPatchBodyOptions {
  effectiveAtChanged: boolean;
  isAuditingRequest: boolean;
  isEdit: boolean;
}

/**
 * Builds a status-change PATCH body without replacing the original timestamp
 * when the date field was not edited.
 *
 * @param data - Current status-change form values
 * @param options - Form mode and dirty-date state
 * @returns PATCH body with effectiveAt only when its date changed
 */
export function buildMemberStatusChangeRequestPatchBody(
  data: MemberStatusChangeRequestForm | MemberStatusChangeRequestAuditForm,
  options: BuildPatchBodyOptions
): UpdateMemberStatusChangeRequestRequest {
  const { effectiveAt, ...requestFields } = data;

  return {
    ...requestFields,
    ...(options.effectiveAtChanged && {
      effectiveAt: DateTime.fromFormat(effectiveAt, 'yyyy-MM-dd').toMillis(),
    }),
    approval:
      options.isEdit && !options.isAuditingRequest ? null : data.approval,
  };
}
